import { useQuery } from 'react-query';
import Holiday from '../../../models/Holiday';

function useHolidays(year: number) {
    return useQuery<Holiday[]>(['holidays', '?year=', year]);
}

export default useHolidays;
